<template>
  <div class="intendedPatientDetail">
    <div class="header">
      <div class="header_left">
        <div class="header_left_title">意向患者信息表</div>
      </div>
      <div class="header_right">
        <div class="header_right_btn btn_back" @click="toBack">返回列表</div>
        <div class="header_right_btn btn_history" @click="historyOpen">历史咨询记录</div>
        <div v-if="$route.params.id !== id" class="header_right_btn btn_history" @click="toNowDetail">回到最新咨询记录</div>
        <div v-if="form.convertStat === 1 || (form.convertStat === 2 && (['', null, undefined, 0].includes(form.isAddWechat) || ['', null, undefined, 0].includes(form.isValid)))" class="header_right_btn btn_edit" @click="toEdit">编辑</div>
      </div>
    </div>
    <div class="content">
      <el-form ref="form" class="content_form" :model="form" label-width="130px">
        <div class="sector">
          <div class="sector_title">系统信息</div>
          <div class="sector_info">
            <el-row :gutter="44">
              <el-col :span="8">
                <el-form-item label="渠道：">
                  <div class="form_text">{{ form.channelName }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="运营人员：">
                  <div class="form_text">{{ form.operatorUserName }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="线索时间：">
                  <div class="form_text">{{ new Date(form.inputDate).Format('yyyy-MM-dd') }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="44">
              <el-col :span="8">
                <el-form-item label="咨询人员：">
                  <div class="form_text">{{ form.consultUserName }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="备注：">
                  <div class="form_text">{{ form.remark }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="预约到馆时间：：">
                  <div class="form_text">{{ new Date(form.appointmentArrivalTime).Format('yyyy-MM-dd') }}</div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="sector">
          <div class="sector_title">基础信息</div>
          <div class="sector_info">
            <el-row :gutter="44">
              <el-col :span="8">
                <el-form-item label="微信号：">
                  <div class="form_text">{{ form.patientWechat }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="电话：">
                  <div class="form_text">{{ form.patientPhone }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="44">
              <el-col :span="8">
                <el-form-item label="是否确定医生：">
                  <div class="form_text">{{ form.isConfirmDoctor == 1 ? '是' : '否' }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="意向医生：">
                  <div class="form_text">{{ form.doctorName }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="推荐医生：">
                  <div class="form_text">{{ form.recommendDoctorName }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="44">
              <el-col :span="16">
                <el-form-item label="咨询问题：">
                  <div class="form_text">{{ form.question }}</div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="sector">
          <div class="sector_title">联系情况</div>
          <div class="sector_info">
            <el-row :gutter="44">
              <el-col :span="8">
                <el-form-item label="是否添加微信：">
                  <div v-if="form.isAddWechat == 1" class="form_text">未加上</div>
                  <div v-if="form.isAddWechat == 2" class="form_text">已加上</div>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="客资是否有效：">
                  <div v-if="form.isValid == 1" class="form_text">无效</div>
                  <div v-if="form.isValid == 2" class="form_text">有效</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="44">
              <el-col :span="16">
                <el-form-item label="沟通情况：">
                  <div class="form_text">{{ form.communication }}</div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="sector">
          <div class="sector_title">转化情况</div>
          <div class="sector_info">
            <el-row :gutter="44">
              <el-col :span="8">
                <el-form-item label="转化情况：">
                  <div v-if="form.convertStat == 1" class="form_text">未转化</div>
                  <div v-if="form.convertStat == 2 && form.convertTyp == 1" class="form_text">已挂号</div>
                  <div v-if="form.convertStat == 2 && form.convertTyp == 2" class="form_text">已网诊</div>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="form.convertStat == 2 && form.convertTyp == 1">
                <el-form-item label="推荐人工号：">
                  <div class="form_text">{{ form.recommendCode ? `${form.recommendCode} | ${form.recommendName}` : '' }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="form.convertStat == 2 && form.convertTyp == 2">
                <el-form-item label="网诊信息：">
                  <div class="form_text">{{ new Date(form.webChatOrderInfo.createTime).Format('yyyy-MM-dd hh:mm:ss') }} | {{ form.webChatOrderInfo.doctorName }} | ￥{{ form.webChatOrderInfo.realPay }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="form.convertStat == 2">
                <el-form-item label="就诊情况：">
                  <div v-if="form.convertTyp == 1" class="form_text">{{ Number(form.orderRegistered.orderStatus) >= 2 ? '已到诊' : '未到诊' }}<span v-if="['3'].includes(form.orderRegistered.registerStatus) || form.orderPayInfo.orderPayState"> | {{ form.orderPayInfo.orderPayState ? '已支付' : '待支付' }} {{ form.orderPayInfo.orderPayState ? `￥${form.orderPayInfo.orderPayPrice}` : '' }}</span></div>
                  <div v-if="form.convertTyp == 2 && (['2', '3'].includes(form.webChatOrderInfo.status) || form.orderPayInfo.orderPayState)" class="form_text">{{ form.orderPayInfo.orderPayState ? '已支付' : '待支付' }} {{ form.orderPayInfo.orderPayState ? `￥${form.orderPayInfo.orderPayPrice}` : '' }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="44">
              <el-col :span="16" v-if="form.convertStat == 2 && form.convertTyp == 1">
                <el-form-item label="挂号信息：">
                  <div class="form_text">{{ new Date(form.orderRegistered.createTime).Format('yyyy-MM-dd hh:mm:ss') }} | {{ form.orderRegistered.deptName }} | {{ form.orderRegistered.doctorName }} | {{ form.orderRegistered.typeName }} | ￥{{ form.orderRegistered.realPay }}</div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
    </div>
    <el-drawer
      class="historyDrawer"
      title="历史咨询记录"
      :visible.sync="historyMap.visible"
      size="450px"
      :modal="false"
      :before-close="historyClose">
      <div class="history_content">
        <div v-if="historyMap.unconvertedList.length > 0" class="history_sector">
          <div class="history_sector_title">最新咨询记录</div>
          <div class="history_sector_list">
            <div v-for="item in historyMap.unconvertedList" :key="item.id" :class="{ history_sector_item: true, history_active: item.id === Number(id) }" @click="toHistoryDetail(item.id)">
              <div class="history_sector_item_header">
                <div class="history_sector_item_title">{{ new Date(item.inputDate).Format('yyyy-MM-dd') }} | {{ item.channelName }}</div>
              </div>
              <div class="history_sector_item_row">
                <div class="history_sector_item_label">意向医生：</div>
                <div class="history_sector_item_value">{{ item.doctorName }}</div>
              </div>
              <div class="history_sector_item_row">
                <div class="history_sector_item_label">咨询问题：</div>
                <div class="history_sector_item_value">{{ item.question }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="historyMap.convertedList.length > 0" class="history_sector">
          <div class="history_sector_title">咨询转化记录</div>
          <div class="history_sector_list">
            <div v-for="item in historyMap.convertedList" :key="item.id" :class="{ history_sector_item: true, history_active: item.id === Number(id) }" @click="toHistoryDetail(item.id)">
              <div class="history_sector_item_header">
                <div class="history_sector_item_title">{{ new Date(item.inputDate).Format('yyyy-MM-dd') }} | {{ item.channelName }}</div>
                <div v-if="item.convertTyp === 1" class="history_sector_item_tag tag_blue">挂号</div>
                <div v-if="item.convertTyp === 2" class="history_sector_item_tag tag_green">网诊</div>
              </div>
              <div class="history_sector_item_row">
                <div class="history_sector_item_label">意向医生：</div>
                <div class="history_sector_item_value">{{ item.doctorName }}</div>
              </div>
              <div class="history_sector_item_row">
                <div class="history_sector_item_label">咨询问题：</div>
                <div class="history_sector_item_value">{{ item.question }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
  import { getIntentDetail, getIntentHistory } from "@/api/operation"
  export default {
    name: 'intendedPatientDetail',
    data () {
      return {
        id: '',
        form: {
          channelCode: '',
          channelName: '',
          operatorUserId: '',
          operatorUserName: '',
          inputDate: '',
          consultUserId: '',
          consultUserName: '',
          remark: '',
          appointmentArrivalTime: '',
          patientWechat: '',
          patientPhone: '',
          isConfirmDoctor: '',
          intentDoctorId: '',
          doctorName: '',
          recommendDoctorId: '',
          recommendDoctorName: '',
          question: '',
          isAddWechat: '',
          isValid: '',
          communication: '',
          convertStat: '',
          convertTyp: '',
          recommendCode: '',
          recommendName: '',
          orderRegistered: {
            registerStatus: '',
            orderStatus: '',
            createTime: '',
            deptName: '',
            doctorName: '',
            typeName: '',
            realPay: 0
          },
          webChatOrderInfo: {
            createTime: '',
            doctorName: '',
            realPay: 0,
            status: ''
          },
          orderPayInfo: {
            orderPayState: false,
            orderPayPrice: 0
          }
        },
        historyMap: {
          visible: false,
          unconvertedList: [],
          convertedList: []
        }
      }
    },
    methods: {
      async getDetail () {
        const res = await getIntentDetail({ id: this.id })
        if (res.code === 200) {
          Object.keys(this.form).forEach(key => {
            if (!['orderRegistered', 'webChatOrderInfo', 'orderPayInfo'].includes(key)) {
              this.form[key] = res.data[key]
            }
          })

          // 挂号信息处理
          const typeMap = { 
            '0': '普通号',
            '1': '加号',
            '2': '特约号',
            '3': '特约加号',
            '4': '理疗',
            '5': '义诊',
            '6': '理疗加号',
            '7': '义诊加号',
            '8': '补录挂号',
            '9': '补录挂号',
            '10': '转方号',
            '11': '转方加号'
          }
          this.form.orderRegistered.registerStatus = res.data.orderRegistered && res.data.orderRegistered.registerStatus || ''
          this.form.orderRegistered.orderStatus = res.data.orderRegistered && res.data.orderRegistered.orderInfo && res.data.orderRegistered.orderInfo.status || ''
          this.form.orderRegistered.createTime = res.data.orderRegistered && res.data.orderRegistered.createTime || ''
          this.form.orderRegistered.deptName = res.data.orderRegistered && res.data.orderRegistered.sysDept && res.data.orderRegistered.sysDept.deptName || ''
          this.form.orderRegistered.doctorName = res.data.orderRegistered && res.data.orderRegistered.doctorName || ''
          this.form.orderRegistered.typeName = res.data.orderRegistered && typeMap[res.data.orderRegistered.type] || ''
          this.form.orderRegistered.realPay = res.data.orderRegistered && res.data.orderRegistered.realPay || 0

          // 网诊信息处理
          this.form.webChatOrderInfo.createTime = res.data.webChatOrderInfo && res.data.webChatOrderInfo.createTime || ''
          this.form.webChatOrderInfo.doctorName = res.data.webChatOrderInfo && res.data.webChatOrderInfo.doctorName || ''
          this.form.webChatOrderInfo.realPay = res.data.webChatOrderInfo && res.data.webChatOrderInfo.realPay || 0
          this.form.webChatOrderInfo.status = res.data.webChatOrderInfo && res.data.webChatOrderInfo.status || ''

          // 处方信息处理
          this.form.orderPayInfo.orderPayState = res.data.orderPayRecords && res.data.orderPayRecords.length > 0 ? true : false
          let orderPayPrice = 0
          res.data.orderPayRecords && res.data.orderPayRecords.forEach(v => {
            orderPayPrice += v.payPrice
          })
          res.data.orderRefundRecords && res.data.orderRefundRecords.forEach(v => {
            orderPayPrice -= v.refundAmount
          })
          orderPayPrice = Math.round(orderPayPrice * 100) / 100
          this.form.orderPayInfo.orderPayPrice = orderPayPrice
        }
      },
      async getHistory() {
        const res = await getIntentHistory({ patientPhone: this.form.patientPhone, patientWechat: this.form.patientWechat })
        if (res.code === 200) {
          res.data.forEach(v => {
            if (v.convertStat === 2) {
              this.historyMap.convertedList.push(v)
            } else {
              this.historyMap.unconvertedList.push(v)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      },
      toBack () {
        this.$router.back()
      },
      toEdit () {
        this.$router.push(`/patient/intendedPatient/edit/${this.id}`)
      },
      historyOpen () {
        this.historyMap.visible = true
        this.getHistory()
      },
      historyClose () {
        this.historyMap.visible = false
        this.historyMap.unconvertedList = []
        this.historyMap.convertedList = []
      },
      toNowDetail () {
        this.id = this.$route.params.id
        this.getDetail()
      },
      toHistoryDetail (id) {
        if (id !== Number(this.id)) {
          this.id = id
          this.getDetail()
        }
      }
    },
    created () {
      this.toNowDetail()
    }
  }
</script>

<style lang="less" scoped>
  .intendedPatientDetail {
    box-sizing: border-box;
    position: relative;
    z-index: 1000;
    margin: 20px;
    width: calc(100% - 40px);
    height: calc(100% - 40px);
    background-color: #FFFFFF;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .header {
    box-sizing: border-box;
    position: sticky;
    z-index: 2;
    top: 0px;
    left: 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    width: 100%;
    height: 64px;
    border-bottom: 1px solid #E5E6EB;
  }

  .header_left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .header_left_title {
    font-weight: bold;
    font-size: 20px;
    color: #1D2129;
  }

  .header_right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .header_right_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 16px;
    height: 32px;
    font-size: 14px;
    border-radius: 4px;
    cursor: pointer;
  }

  .header_right_btn+.header_right_btn {
    margin: 0 0 0 8px;
  }

  .header_right_btn.btn_back {
    color: #4E5969;
    background-color: #FFFFFF;
    border: 1px solid #D9D9D9;
  }

  .header_right_btn.btn_history {
    color: #4E5969;
    background-color: #FFFFFF;
    border: 1px solid #D9D9D9;
  }

  .header_right_btn.btn_edit {
    color: #FFFFFF;
    background-color: #1890FF;
  }

  .content {
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
  }

  .content_form {
    width: 100%;
  }

  .content_form /deep/ .el-form-item {
    margin-bottom: 0px;
  }

  .sector {
    width: 100%;
  }

  .sector+.sector {
    margin: 32px 0 0 0;
  }

  .sector_title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 22px;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .sector_title::before {
    content: '';
    display: block;
    margin: 0 8px 0 0;
    width: 3px;
    height: 16px;
    background-color: #1890FF;
  }

  .sector_info {
    margin: 16px 0 0 0;
    width: 100%;
  }

  .form_text {
    width: 100%;
    font-size: 14px;
    color: #1D2129;
    word-break: break-all;
  }

  .historyDrawer /deep/ .el-drawer__header {
    margin-bottom: 0px;
    padding-bottom: 20px;
    color: #291D22;
    border-bottom: 1px solid #E5E6EB;
  }

  .history_content {
    box-sizing: border-box;
    padding: 20px 8px;
    width: 100%;
  }

  .history_sector {
    width: 100%;
  }

  .history_sector+.history_sector {
    margin: 32px 0 0 0;
  }

  .history_sector_title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .history_sector_title::before {
    content: '';
    display: block;
    margin: 0 8px 0 0 ;
    width: 3px;
    height: 16px;
    background-color: #1890FF;
  }

  .history_sector_list {
    margin: 12px 0 0 0;
    width: 100%;
  }

  .history_sector_item {
    box-sizing: border-box;
    padding: 12px 16px;
    width: 100%;
    background-color: #FFFFFF;
    border: 1px solid #E5E6EB;
    border-radius: 6px;
    cursor: pointer;
  }

  .history_sector_item.history_active {
    background-color: #F4F9FF;
    border-color: #1890FF;
  }

  .history_sector_item+.history_sector_item {
    margin: 16px 0 0 0;
  }

  .history_sector_item_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .history_sector_item_title {
    line-height: 22px;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .history_sector_item_tag {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 22px;
    font-size: 12px;
    border-radius: 4px;
  }

  .history_sector_item_tag.tag_blue {
    color: #1890FF;
    background-color: #E1F1FF;
  }

  .history_sector_item_tag.tag_green {
    color: #29C01B;
    background-color: #DCFCD9;
  }

  .history_sector_item_row {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 8px 0 0 0;
    width: 100%;
  }

  .history_sector_item_label {
    flex-shrink: 0;
    line-height: 20px;
    font-size: 14px;
    color: #86909C;
  }

  .history_sector_item_value {
    display: flex;
    flex-wrap: wrap;
    line-height: 20px;
    font-size: 14px;
    color: #4B4B4B;
    word-break: break-all;
  }
</style>
